module.exports = __webpack_public_path__ + "static/img/banner.da10bc4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner.png
// module id = 405
// module chunks = 1